var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],ref:"alert"}),_c('Dashboard',{ref:"dashboard",attrs:{"dashboards":_vm.dashboards}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }